(function () {
  'use strict';

  var CLICK_KEY = 'snagAppClickedUntil';
  var DAY = 86400000;

  function read(key) {
    try { return parseInt(window.localStorage.getItem(key), 10) || 0; } catch (e) { return 0; }
  }

  function write(key, days) {
    try { window.localStorage.setItem(key, String(Date.now() + days * DAY)); } catch (e) {}
  }

  function snoozed(key) {
    return read(key) > Date.now();
  }

  var CLOSES_KEY = 'snagAppCloses';
  var GONE_DAYS = 365;

  if (/[?&]app_banner=off\b/.test(window.location.search)) write(CLICK_KEY, GONE_DAYS);

  var VISITS_KEY = 'snagAppVisits';
  var SEEN_KEY = 'snagAppLastSeen';
  var VISIT_GAP = 30 * 60000;

  var visits = (function () {
    try {
      var store = window.localStorage;
      var count = parseInt(store.getItem(VISITS_KEY), 10) || 0;
      var now = Date.now();
      if (now - (parseInt(store.getItem(SEEN_KEY), 10) || 0) > VISIT_GAP) {
        count += 1;
        store.setItem(VISITS_KEY, String(count));
      }
      store.setItem(SEEN_KEY, String(now));
      return count;
    } catch (e) { return 0; }
  })();

  function enoughVisits(el) {
    var min = parseInt(el.dataset.minVisits, 10);
    return visits >= (isNaN(min) ? 3 : min);
  }

  function isDesktop() {
    var ua = navigator.userAgent;
    if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return false;
    if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return false;
    return !window.matchMedia('(pointer: coarse)').matches;
  }

  function isInAppBrowser() {
    var ua = navigator.userAgent || '';
    if (/FBAN|FBAV|FB_IAB|FBIOS|Instagram|Messenger|TikTok|musical_ly|Bytedance|Snapchat|Pinterest|LinkedInApp|\bLine\/|Twitter|WhatsApp/i.test(ua)) return true;
    if (/Android/.test(ua) && /; wv\)/.test(ua)) return true;
    var ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    return ios && !/Safari\//.test(ua);
  }

  function today() {
    var d = new Date();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + day;
  }

  function offerLive(el) {
    var start = el.dataset.offerStart;
    var end = el.dataset.offerEnd;
    if (!start) return false;
    var t = today();
    return t >= start && (!end || t <= end);
  }

  function hideAll() {
    document.querySelectorAll('snag-app-banner, snag-app-nudge').forEach(function (n) { n.hidden = true; });
    document.querySelectorAll('snag-app-topbar').forEach(function (n) { n.close(); });
    document.querySelectorAll('.snag-app-banner-section').forEach(function (n) { n.hidden = true; });
  }

  function countClose(el) {
    var closes = read(CLOSES_KEY) + 1;
    try { window.localStorage.setItem(CLOSES_KEY, String(closes)); } catch (e) {}
    if (closes >= (parseInt(el.dataset.maxCloses, 10) || 2)) {
      write(CLICK_KEY, GONE_DAYS);
      hideAll();
    }
  }

  function trackClicks(el) {
    var days = parseInt(el.dataset.clickDays, 10) || 180;
    el.querySelectorAll('[data-app-cta]').forEach(function (a) {
      a.addEventListener('click', function () {
        write(CLICK_KEY, days);
        window.setTimeout(hideAll, 400);
      });
    });
  }

  class SnagAppBanner extends HTMLElement {
    connectedCallback() {
      var dismissKey = 'snagAppBannerDismissedUntil';
      if (snoozed(CLICK_KEY) || snoozed(dismissKey)) return;
      if (!enoughVisits(this)) return;
      if (isInAppBrowser()) return;
      if (this.dataset.showDesktop !== 'true' && isDesktop()) return;

      var mode = offerLive(this) ? 'offer' : 'standard';
      this.querySelectorAll('[data-copy]').forEach(function (c) {
        c.hidden = c.dataset.copy !== mode;
      });

      var close = this.querySelector('[data-app-dismiss]');
      var self = this;
      if (close) {
        close.addEventListener('click', function () {
          write(dismissKey, parseInt(self.dataset.dismissDays, 10) || 30);
          self.hidden = true;
          var wrap = self.closest('.shopify-section');
          if (wrap) wrap.hidden = true;
          countClose(self);
        });
      }

      trackClicks(this);
      this.hidden = false;
    }
  }

  class SnagAppNudge extends HTMLElement {
    connectedCallback() {
      if (snoozed(CLICK_KEY)) return;
      if (!enoughVisits(this)) return;
      if (isInAppBrowser()) return;
      if (isDesktop()) return;
      trackClicks(this);
      this.hidden = false;
    }
  }

  class SnagAppTopbar extends HTMLElement {
    connectedCallback() {
      var editor = this.hasAttribute('data-editor');
      if (!editor && this.parentNode !== document.body) {
        document.body.appendChild(this);
        return;
      }
      if (this.started) return;
      this.started = true;
      this.dismissKey = 'snagAppTopbarDismissedUntil';

      if (editor) {
        if (this.dataset.showDesktop !== 'true' && !window.matchMedia('(max-width: 767px)').matches) return;
      } else {
        if (snoozed(CLICK_KEY) || snoozed(this.dismissKey)) return;
        if (!enoughVisits(this)) return;
        if (isInAppBrowser()) return;
        if (this.dataset.showDesktop !== 'true' && isDesktop()) return;
      }

      var mode = offerLive(this) ? 'offer' : 'standard';
      this.querySelectorAll('[data-copy]').forEach(function (c) {
        c.hidden = c.dataset.copy !== mode;
      });

      var self = this;
      var close = this.querySelector('[data-app-dismiss]');
      if (close) {
        close.addEventListener('click', function () {
          write(self.dismissKey, parseInt(self.dataset.dismissDays, 10) || 14);
          self.close();
          countClose(self);
        });
      }
      trackClicks(this);

      if (editor) {
        this.hidden = false;
        this.classList.add('is-open');
        return;
      }

      var delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
      window.setTimeout(function () { self.drop(); }, delay);
    }

    drop() {
      var self = this;
      var header = document.querySelector('.shopify-section[id$="__header"]');
      var top = header ? header.getBoundingClientRect().top : 0;
      if (top > 24 && top < 140) this.style.setProperty('--app-topbar-h', top + 'px');
      this.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { self.classList.add('is-open'); });
      });
    }

    close() {
      var self = this;
      if (this.hidden) return;
      this.classList.remove('is-open');
      window.setTimeout(function () { self.hidden = true; }, 500);
    }
  }

  if (!customElements.get('snag-app-banner')) customElements.define('snag-app-banner', SnagAppBanner);
  if (!customElements.get('snag-app-nudge')) customElements.define('snag-app-nudge', SnagAppNudge);
  if (!customElements.get('snag-app-topbar')) customElements.define('snag-app-topbar', SnagAppTopbar);
})();
